import {Component, forwardRef, Input, OnInit, ElementRef, Output, EventEmitter} from '@angular/core';
import {CommonsService} from "../../../core/service/commons.service";
import {PersonService} from "../../../routes/jy-org/person/service/person.service";
import {CacheService} from '@delon/cache';
/**
 * 字典组件
 * 若要多选,mode传multiple,dictItemCode传数组
 */
@Component({
  selector: 'person-card',
  templateUrl: './person-card.html',
  styleUrls: ['./person-card.less']
})

export class PersonCardComponent implements OnInit {
  ngOnInit():void {
  }

  @Input() name:string;

  @Input() id:number;

  person:any = {};

  constructor(private personService:PersonService, private commonsService:CommonsService, private srv:CacheService) {
  }

  loadPerson(event) {
    if (event && this.id) {
      let person = this.srv.getNone("" + this.id)
      if (person) {
        this.person = person;
      } else {
        this.personService.personCard(this.id).subscribe((data)=> {
          let arr = data.positions;
          let positionName = "";
          arr.forEach(position => {
            positionName += position.name + ", ";
          });
          data.positionNames = positionName.substring(0,positionName.length -2);
          this.person = data;
          this.srv.set("" + this.id, this.person, {expire: 1800})
        })
      }
    }
  }

}
